import React from 'react';
import Form, { DateInput, FormBody } from "../../Form";
import { Link } from "react-router";
import moment from "moment";

export default class ObservationTaskBar extends React.Component {
  render() {
    const { slug } = this.props;
    const { date_from, date_to, handleFromChange, handleToChange, getObservations, reset } = this.props;

    return <Form>
      <FormBody>
        <div className='inline-grid space-between v-center'>
          <Link className="toggle" to={`/analysis/hqc/add_parameter?slug=${slug}`}><button>Add Parameter</button></Link>
          <DateInput value={moment(date_from).format('YYYY-MM-DD')} onChange={handleFromChange} label={'From'} />
          <DateInput value={moment(date_to).format('YYYY-MM-DD')} onChange={handleToChange} label={'To'} />
          <i className={'fa fa-refresh'} style={{ cursor: 'pointer' }} onClick={getObservations} />
          <button onClick={reset}>Reset</button>
        </div>
      </FormBody>
    </Form>;
  }
}


// WEBPACK FOOTER //
// ./src/components/HQC/_commons/ObservationTaskBar.js